import { Color3 } from "@babylonjs/core/Maths/math.color";
import { Mesh } from "@babylonjs/core/Meshes/mesh";
import { CreateBox } from "@babylonjs/core/Meshes/Builders/boxBuilder";
import { CreateCylinder } from "@babylonjs/core/Meshes/Builders/cylinderBuilder";
import { Quaternion } from "@babylonjs/core/Maths/math.vector";
import { Vector3 } from "@babylonjs/core/Maths/math.vector";
import { GeoUtils } from "./GeoUtils";
import { Util } from "../../utils/Util";
import { WallOpening } from '../WallOpening';
import { CameraModeMask, CameraControl } from '@egr/wcf/modules/core/view/CameraControl';
import { ElementChangedFlags } from '@egr/wcf/modules/core/mdl';
import { PbrMaterial } from '@egr/wcf/modules/core/mdl';
import { ShadowGenerator } from "@egr/wcf/modules/core/rendering/ShadowGenerator";
import { VECTOR3_Y } from "@egr/wcf/modules/core/utils/MathUtils";
import { clamp, eq, degToRad } from "@egr/wcf/modules/utils/math";
export class OpeningGeometry {
    constructor(pRoomManager, pOpening) {
        this.mOpening = pOpening;
        this.mRoomManager = pRoomManager;
        this.mScene = pRoomManager.app.model.scene;
        this.mMatManager = pRoomManager.app.model.materials;
    }
    get canMirrorH() {
        return (true);
    }
    get canMirrorV() {
        return (true);
    }
    getInitialParams() {
        let tParams = {};
        tParams.width = 1;
        tParams.height = 1;
        tParams.floorOffset = 1;
        return (tParams);
    }
    create2dGeometry(pParent) {
        //use in instances
    }
    create3dGeometry(pParent) {
        //use in instances
    }
    getProperties() {
        return (null);
    }
    serializeIOData() {
        return (null);
    }
    loadIOData(pData) {
        //use in instances
    }
    setGlazingBars(pGlazingBars, pOpeningParams) {
        if (pOpeningParams.glazingBars === pGlazingBars)
            return (false);
        pOpeningParams.glazingBars = pGlazingBars;
        this.mOpening.beginChange();
        this.mOpening.updateGeometry();
        this.mOpening.notifyChange(ElementChangedFlags.Properties);
        this.mOpening.endChange();
        return (true);
    }
    setGlazingBarsWidth(pGlazingBarsWidth, pOpeningParams) {
        let tValue = clamp(pGlazingBarsWidth, 0.01, 0.1);
        if (pOpeningParams.glazingBars_width === tValue)
            return (false);
        pOpeningParams.glazingBars_width = tValue;
        this.mOpening.beginChange();
        this.mOpening.updateGeometry();
        this.mOpening.notifyChange(ElementChangedFlags.Properties);
        this.mOpening.endChange();
        return (true);
    }
    setGlazingBarsHorizontal(pGlazingBarsCount, pOpeningParams) {
        let tValue = clamp(pGlazingBarsCount, 1, 99);
        tValue = Math.trunc(tValue);
        if (pOpeningParams.glazingBars_h_segments === tValue)
            return (false);
        pOpeningParams.glazingBars_h_segments = tValue;
        this.mOpening.beginChange();
        this.mOpening.updateGeometry();
        this.mOpening.notifyChange(ElementChangedFlags.Properties);
        this.mOpening.endChange();
        return (true);
    }
    setGlazingBarsVertical(pGlazingBarsCount, pOpeningParams) {
        let tValue = clamp(pGlazingBarsCount, 1, 99);
        tValue = Math.trunc(tValue);
        if (pOpeningParams.glazingBars_v_segments === tValue)
            return (false);
        pOpeningParams.glazingBars_v_segments = tValue;
        this.mOpening.beginChange();
        this.mOpening.updateGeometry();
        this.mOpening.notifyChange(ElementChangedFlags.Properties);
        this.mOpening.endChange();
        return (true);
    }
    setSegments(pSegments, pOpeningParams) {
        let tValue = clamp(pSegments, 1, 50.0);
        if (eq(pOpeningParams.ColumnCount, tValue))
            return (false);
        pOpeningParams.ColumnCount = Math.trunc(tValue);
        pOpeningParams.ColumnWidth = this.mOpening.width / tValue;
        switch (this.mOpening.type) {
            case "Window":
            case "WindowDouble":
                if (pOpeningParams.ColumnWidth < 0.24) {
                    let t_val = this.mOpening.width / 0.24;
                    pOpeningParams.ColumnCount = Math.trunc(t_val);
                    pOpeningParams.ColumnWidth = this.mOpening.width / t_val;
                }
                break;
            default:
                //
                break;
        }
        this.mOpening.beginChange();
        this.mOpening.updateGeometry();
        this.mOpening.notifyChange(ElementChangedFlags.PropertyValues);
        this.mOpening.endChange();
        return (true);
    }
    setSegmentsWidth(pWidth, pOpeningParams) {
        let tValue = clamp(pWidth, 0.1, 50.0);
        if (eq(pOpeningParams.ColumnWidth, tValue))
            return (false);
        pOpeningParams.ColumnWidth = tValue;
        this.mOpening.beginChange();
        this.mOpening.updateGeometry();
        this.mOpening.notifyChange(ElementChangedFlags.PropertyValues);
        this.mOpening.endChange();
        return (true);
    }
    setBlind(pBlind, pOpeningParams) {
        if (pOpeningParams.blindVisible === pBlind)
            return (false);
        pOpeningParams.blindVisible = pBlind;
        this.mOpening.beginChange();
        this.mOpening.updateGeometry();
        this.mOpening.notifyChange(ElementChangedFlags.Properties);
        this.mOpening.endChange();
        return (true);
    }
    setWindowSill(pSill, pOpeningParams) {
        if (pOpeningParams.windowSill === pSill)
            return (false);
        pOpeningParams.windowSill = pSill;
        this.mOpening.beginChange();
        this.mOpening.updateGeometry();
        this.mOpening.notifyChange(ElementChangedFlags.Properties);
        this.mOpening.endChange();
        return (true);
    }
    setPrivacyFilter(pPrivacyFilter, pOpeningParams) {
        if (pOpeningParams.privacyFilter === pPrivacyFilter)
            return (false);
        pOpeningParams.privacyFilter = pPrivacyFilter;
        this.mOpening.beginChange();
        this.mOpening.updateGeometry();
        this.mOpening.notifyChange(ElementChangedFlags.Properties);
        this.mOpening.endChange();
        return (true);
    }
    setBlindOpeningAngle(pBlindOpeningAngle, pOpeningParams) {
        let tValue = clamp(pBlindOpeningAngle, -90, 90);
        if (eq(pOpeningParams.blindOpeningAngle, tValue))
            return (false);
        pOpeningParams.blindOpeningAngle = tValue;
        this.mOpening.beginChange();
        this.mOpening.updateGeometry();
        this.mOpening.notifyChange(ElementChangedFlags.PropertyValues);
        this.mOpening.endChange();
        return (true);
    }
    setBlindOpeningWidth(pBlindOpeningWidth, pOpeningParams) {
        let tValue = clamp(pBlindOpeningWidth, 0, this.mOpening.width);
        if (eq(pOpeningParams.blindOpeningWidth, tValue))
            return (pOpeningParams);
        pOpeningParams.blindOpeningWidth = tValue;
        this.mOpening.beginChange();
        this.mOpening.updateGeometry();
        this.mOpening.notifyChange(ElementChangedFlags.PropertyValues);
        this.mOpening.endChange();
        return (pOpeningParams);
    }
    createBlind(pParent, pOpeningParams) {
        if (!pOpeningParams.blindVisible)
            return;
        let tHeight = this.mOpening.height;
        let tDepth = this.mOpening.depth;
        let tHW = this.mOpening.width;
        let tBlind = [];
        let tSlatNumber = Math.round(tHW / pOpeningParams.blindDepth);
        let tHW1 = tSlatNumber * pOpeningParams.blindDepth;
        var tOverlap = 0;
        if (tHW1 > tHW)
            tOverlap = (tHW1 - tHW) / (tSlatNumber - 1);
        else
            tHW = tHW1;
        if (pOpeningParams.blindOpeningWidth > 0) {
            tOverlap = (tHW1 - (tHW - pOpeningParams.blindOpeningWidth)) / (tSlatNumber);
        }
        for (let i = 1; i <= tSlatNumber; i++) {
            let tSPh = (pOpeningParams.blindDepth * 0.5 * i);
            let tGap = (pOpeningParams.blindDepth * 0.5 * (i - 1)) - (tOverlap * (i - 1));
            let tSP = -tHW * 0.5 + tSPh + tGap;
            let tSlat = CreateBox("", {
                width: 0.0005, height: tHeight - 0.02, depth: pOpeningParams.blindDepth
            }, this.mScene);
            tSlat.position.x = tSP;
            if (this.mOpening.mirrorHorizontal)
                tSlat.position.x = -tSlat.position.x;
            tSlat.position.y = tHeight * 0.5;
            tSlat.position.z = -tDepth * 0.5 - pOpeningParams.blindDepth * 0.5 - 0.02;
            if (this.mOpening.mirrorHorizontal)
                tSlat.position.z = -tSlat.position.z;
            let tAxis = new Vector3(0, 1, 0);
            let tAngle = (pOpeningParams.blindOpeningAngle - 90) / 180 * Math.PI;
            let tQuaternion = Quaternion.RotationAxis(tAxis, tAngle);
            tSlat.rotationQuaternion = tQuaternion;
            tBlind.push(tSlat);
        }
        let tMesh = Mesh.MergeMeshes(tBlind);
        tMesh.position.y = 0.004;
        tMesh.material = this.getGrayPlasticMaterial();
        tMesh.parent = pParent;
        if (this.mOpening.wall != null)
            tMesh.name = "room:wall|" + this.mOpening.wall.id.toString();
        this.prepare3dMesh(tMesh);
        this.createBlindHolder(tMesh, pOpeningParams);
    }
    createBlindHolder(pParent, pOpeningParams) {
        let tW = this.mOpening.width;
        let tH = this.mOpening.height;
        let tDepth = this.mOpening.depth;
        let tH1 = CreateBox("", {
            width: tW, height: 0.005, depth: 0.0025
        }, this.mScene);
        tH1.position.z = 0.0055;
        tH1.position.y = 0.0125;
        let tH2 = CreateBox("", {
            width: tW, height: 0.0025, depth: 0.0135
        }, this.mScene);
        tH2.position.y = 0.015;
        let tH3 = tH1.clone("");
        if (tH3 == null)
            return;
        tH3.position.z = -0.0055;
        let tMesh = Mesh.MergeMeshes([tH1, tH2, tH3]);
        tMesh.material = this.getWhitePlasticMaterial();
        tMesh.position.y = tH - 0.02;
        tMesh.position.z = -tDepth * 0.5 - pOpeningParams.blindDepth * 0.5 - 0.02;
        if (this.mOpening.mirrorHorizontal)
            tMesh.position.z = -tMesh.position.z;
        tMesh.parent = pParent;
        this.prepare3dMesh(tMesh);
    }
    createPrivacyFilter(pParent, pDouble, pLeft = true) {
        let tType = pDouble ? 0.5 : 1;
        let tW = this.mOpening.width;
        let tH = this.mOpening.height;
        let tneg = pLeft ? -1 : 1;
        let tFoil1 = CreateBox("", { width: tW * tType - 0.02, height: 0.01,
            depth: 0.0001
        }, this.mScene);
        let tFoil2 = CreateBox("", { width: tW * tType - 0.02, height: tH * 0.02,
            depth: 0.0001
        }, this.mScene);
        let tFoil3 = CreateBox("", { width: tW * tType - 0.02, height: tH * 0.03,
            depth: 0.0001
        }, this.mScene);
        let tFoil4 = CreateBox("", { width: tW * tType - 0.02, height: tH * 0.04,
            depth: 0.0001
        }, this.mScene);
        tFoil1.position.y = tH * 0.8 - tH * 0.5;
        tFoil2.position.y = tH * 0.78 - tH * 0.5;
        tFoil3.position.y = tH * 0.745 - tH * 0.5;
        tFoil4.position.y = tH * 0.698 - tH * 0.5;
        let tMesh = Mesh.MergeMeshes([tFoil1, tFoil2, tFoil3, tFoil4]);
        tMesh.parent = pParent;
        tMesh.material = this.getMilkGlassMaterial();
        if (this.mOpening.wall != null)
            tMesh.name = "room:wall|" + this.mOpening.wall.id.toString();
        if (this.mOpening.mirrorHorizontal) {
            tMesh.position.z = -tMesh.position.z;
        }
        this.prepare3dMesh(tMesh);
        return tMesh;
    }
    getSheetGlassMaterial() {
        let tMat = this.mMatManager.getMaterial(OpeningGeometry.MAT_KEY_SHEETGLASS);
        if (tMat == null) {
            tMat = new PbrMaterial("", this.mMatManager);
            tMat.albedoColor = new Color3(0.94, 0.98, 0.96).toLinearSpace();
            tMat.metallic = 0;
            tMat.roughness = 0;
            tMat.alpha = 0.05;
            this.mMatManager.addMaterial(OpeningGeometry.MAT_KEY_SHEETGLASS, tMat);
        }
        return (tMat);
    }
    getMilkGlassMaterial() {
        let tMat = this.mMatManager.getMaterial(OpeningGeometry.MAT_KEY_MILKGLASS);
        if (tMat == null) {
            tMat = new PbrMaterial("", this.mMatManager);
            tMat.albedoColor = new Color3(1, 1, 1).toLinearSpace();
            tMat.metallic = 0;
            tMat.roughness = 0.1;
            tMat.alpha = 0.96;
            this.mMatManager.addMaterial(OpeningGeometry.MAT_KEY_MILKGLASS, tMat);
        }
        return (tMat);
    }
    getWhitePlasticMaterial() {
        let tMat = this.mMatManager.getMaterial(OpeningGeometry.MAT_KEY_WHITEPLASTIC);
        if (tMat == null) {
            tMat = new PbrMaterial("", this.mMatManager);
            tMat.albedoColor = Color3.White().toLinearSpace();
            tMat.metallic = 0;
            tMat.roughness = 0.2;
            this.mMatManager.addMaterial(OpeningGeometry.MAT_KEY_WHITEPLASTIC, tMat);
        }
        return (tMat);
    }
    getGrayPlasticMaterial() {
        let tMat = this.mMatManager.getMaterial(OpeningGeometry.MAT_KEY_GRAYPLASTIC);
        if (tMat == null) {
            tMat = new PbrMaterial("", this.mMatManager);
            tMat.albedoColor = new Color3(0.8, 0.8, 0.8).toLinearSpace();
            tMat.metallic = 0;
            tMat.roughness = 0.2;
            this.mMatManager.addMaterial(OpeningGeometry.MAT_KEY_GRAYPLASTIC, tMat);
        }
        return (tMat);
    }
    getMetalMaterial() {
        let tMat = this.mMatManager.getMaterial(OpeningGeometry.MAT_KEY_METAL);
        if (tMat == null) {
            tMat = new PbrMaterial("", this.mMatManager);
            tMat.albedoColor = new Color3(1, 1, 1).toLinearSpace();
            tMat.metallic = 1;
            tMat.roughness = 0.3;
            this.mMatManager.addMaterial(OpeningGeometry.MAT_KEY_METAL, tMat);
        }
        return (tMat);
    }
    prepare2dMesh(pMesh) {
        if (pMesh == null)
            return;
        pMesh.freezeWorldMatrix();
    }
    prepare3dMesh(pMesh) {
        if (pMesh == null)
            return;
        pMesh.freezeWorldMatrix();
        //not visible in top and bottom view
        CameraControl.SetMeshCameraModeMask(pMesh, CameraModeMask.All &
            ~CameraModeMask.Top & ~CameraModeMask.Bottom);
    }
    openOpening(pMesh, pParent, pLeftLeaf = true, pWallThickness = 0) {
        let tW = this.mOpening.width;
        let tneg = pLeftLeaf ? -1 : 1;
        let trotPos = pParent.position.clone();
        trotPos.x = (tneg * tW * 0.5 - 0.0075) - pWallThickness * 0.5;
        trotPos.z = -0.142;
        let trotAngle = -tneg * this.mOpening.OpeningParams.openingAngle;
        if (this.mOpening.mirrorHorizontal) {
            trotPos.z = -trotPos.z;
            trotAngle = -trotAngle;
        }
        if (this.mOpening.mirrorVertical) {
            trotPos.x = tW * 0.5 + 0.0075;
            trotAngle = -trotAngle;
        }
        pMesh.rotateAround(trotPos, VECTOR3_Y, degToRad(trotAngle));
    }
    rotateMesh(pMesh, pRotPos, pLeft = true) {
        let tneg = pLeft ? -1 : 1;
        let trotAngle = -tneg * this.mOpening.OpeningParams.openingAngle;
        let trotPos = pRotPos;
        trotPos.y = 0;
        if (this.mOpening.mirrorHorizontal) {
            trotAngle = -trotAngle;
        }
        if (this.mOpening.mirrorVertical) {
            trotAngle = -trotAngle;
        }
        pMesh.rotateAround(pRotPos, VECTOR3_Y, degToRad(trotAngle));
    }
    openOpening1(pMesh, protPos, pLeftLeaf = true) {
        this.rotateMesh(pMesh, protPos, pLeftLeaf);
    }
    // tslint:disable-next-line:cyclomatic-complexity
    createHinge(pParent, pFrameOffset, pLeft = true, pFrameThickness = 0.04, pLeafDepth = 0.005) {
        let tW = this.mOpening.width;
        let tH = this.mOpening.height;
        if (this.mOpening.OpeningParams.fanlight)
            tH = this.mOpening.height - this.mOpening.OpeningParams.fanlightHeight;
        let tD = this.mOpening.depth;
        let tSide = pLeft ? -1 : 1;
        //hinge
        let tHinge1 = CreateCylinder("", { height: 0.1, diameter: 0.015, tessellation: 8 }, this.mScene);
        tHinge1.position.x = (tSide) * tW * 0.5 + (tSide) * 0.0075;
        tHinge1.position.y = tH * 0.2;
        let t_hingePos = CreateBox("", {
            width: 0.06, height: 0.06, depth: 0.06
        }, this.mScene);
        t_hingePos.position.x = (tSide) * tW * 0.5 + (tSide) * 0.0075;
        t_hingePos.position.y = tH * 0.2;
        if (this.mOpening.mirrorHorizontal) {
            tHinge1.position.z = tD * 0.5 + pFrameOffset - 0.0075;
            t_hingePos.position.z = tD * 0.5 + pFrameOffset - 0.0075;
        }
        else {
            tHinge1.position.z = -tD * 0.5 - pFrameOffset + 0.0075;
            t_hingePos.position.z = -tD * 0.5 - pFrameOffset + 0.0075;
        }
        if (this.mOpening.mirrorVertical) {
            tHinge1.position.x = -tHinge1.position.x;
            t_hingePos.position.x = -t_hingePos.position.x;
        }
        t_hingePos.visibility = 0;
        t_hingePos.parent = pParent;
        this.prepare3dMesh(t_hingePos);
        this.mOpening.setHingePos(t_hingePos.absolutePosition);
        let tHinge2 = tHinge1.clone("");
        if (tHinge2 == null)
            return (Vector3.Zero());
        tHinge2.position.y = tH * 0.8;
        let tMesh = null;
        if (this.mOpening.OpeningParams.doorType === WallOpening.DoorTypes.glass) {
            //hinge box
            let tHingeBox = CreateBox("", {
                width: 0.075, height: 0.05, depth: pFrameThickness - 0.035
            }, this.mScene);
            if (pLeft)
                tHingeBox.position.x = (tSide) * tW * 0.5 + (tSide) * 0.0075 + 0.0375;
            else
                tHingeBox.position.x = (tSide) * tW * 0.5 + (tSide) * 0.0075 - 0.0375;
            tHingeBox.position.y = tH * 0.2 + 0.025;
            if (this.mOpening.mirrorHorizontal)
                tHingeBox.position.z = tD * 0.5 + pFrameOffset - 0.0125;
            else
                tHingeBox.position.z = -tD * 0.5 - pFrameOffset + 0.0125;
            if (this.mOpening.mirrorVertical)
                tHingeBox.position.x = -tHingeBox.position.x;
            let tHingeBox2 = tHingeBox.clone("");
            tHingeBox2.position.y = tH * 0.8 + 0.025;
            ShadowGenerator.disableMeshShadow(tHingeBox);
            ShadowGenerator.disableMeshShadow(tHingeBox2);
            tMesh = Mesh.MergeMeshes([tHinge1, tHinge2, tHingeBox, tHingeBox2]);
            ShadowGenerator.disableMeshShadow(tMesh);
            this.rotateMesh(tMesh, tHinge1.position, pLeft);
        }
        else {
            tMesh = Mesh.MergeMeshes([tHinge1, tHinge2]);
        }
        if (tMesh != null) {
            tMesh.material = this.getMetalMaterial();
            tMesh.parent = pParent;
            if (this.mOpening.wall != null)
                tMesh.name = "room:wall|" + this.mOpening.wall.id.toString();
            this.prepare3dMesh(tMesh);
        }
        ShadowGenerator.disableMeshShadow(tHinge1);
        ShadowGenerator.disableMeshShadow(tHinge2);
        ShadowGenerator.disableMeshShadow(t_hingePos);
        return (tHinge1.position);
    }
    // tslint:disable-next-line:cyclomatic-complexity
    createLeaf(pParent, protPos, pDoorLeaf_Depth, pDouble, pLeft = true, pFRAME_Thickness) {
        if (this.mOpening.wall == null)
            return (null);
        let tType = pDouble ? 0.5 : 1;
        let tW = this.mOpening.width * tType;
        let tH = this.mOpening.height;
        if (this.mOpening.OpeningParams.fanlight) {
            tH = this.mOpening.height - this.mOpening.OpeningParams.fanlightHeight + pFRAME_Thickness;
        }
        let tLeaf = Util.CAG_createBox(tW, pDoorLeaf_Depth, tH, pLeft, this.mScene);
        if (tLeaf == null)
            return (null);
        if (pDouble) {
            if (pLeft)
                tLeaf.position.x = -tW;
            else {
                tLeaf.position.x = 0;
            }
        }
        else {
            tLeaf.position.x = -tW * 0.5;
        }
        tLeaf.position.y = 0;
        // positioning on z axis
        tLeaf.position.z = -this.mOpening.depth * 0.5 - (pDoorLeaf_Depth * 0.75);
        if (this.mOpening.mirrorHorizontal) {
            tLeaf.position.z = -tLeaf.position.z - pDoorLeaf_Depth;
        }
        let tLeafMatData = this.mOpening.MaterialSet_Leaf;
        let tLeafMaterial = this.mRoomManager.getMaterialId(tLeafMatData);
        let tMat = null;
        if (tLeafMaterial.indexOf(this.mRoomManager.materialSplitStr) === -1) {
            tMat = this.mRoomManager._getWallColorMaterial(tLeafMatData.value);
        }
        else {
            tMat = this.mRoomManager.MatManager.getMaterial(tLeafMaterial);
        }
        tLeaf.material = tMat; // this.getWhitePlasticMaterial();
        tLeaf.parent = pParent;
        if (this.mOpening.wall != null)
            tLeaf.name = "room:wall|" + this.mOpening.wall.id.toString();
        this.openOpening1(tLeaf, protPos, pLeft);
        this.prepare3dMesh(tLeaf);
        return (tLeaf);
    }
    createLeaf_GlassInlay(pParent, protPos, pDoorLeaf_Depth, pDouble, pLeft = true, pFRAME_Thickness) {
        const toff = 0.01;
        const tLeafThickness = 0.15;
        let tType = pDouble ? 0.5 : 1;
        let tW = this.mOpening.width * tType;
        let tH = this.mOpening.height;
        let tD = this.mOpening.depth;
        if (this.mOpening.OpeningParams.fanlight) {
            tH = this.mOpening.height - this.mOpening.OpeningParams.fanlightHeight + pFRAME_Thickness;
        }
        let tFrame = GeoUtils.createFrame_CAG(tW, tH, pDoorLeaf_Depth, tLeafThickness, pParent, pLeft, this.mScene);
        if (tFrame == null)
            return (null);
        if (pDouble) {
            if (pLeft) {
                tFrame.position.x = -tW * tType;
            }
            else {
                tFrame.position.x = tW * tType;
            }
        }
        tFrame.position.y = tH * 0.5;
        tFrame.position.z = -(tD * 0.5) - toff;
        let tLeafMatData = this.mOpening.MaterialSet_Leaf;
        let tLeafMaterial = this.mRoomManager.getMaterialId(tLeafMatData);
        let tMat = null;
        if (tLeafMaterial.indexOf(this.mRoomManager.materialSplitStr) === -1) {
            tMat = this.mRoomManager._getWallColorMaterial(tLeafMatData.value);
        }
        else {
            tMat = this.mRoomManager.MatManager.getMaterial(tLeafMaterial);
        }
        tFrame.material = tMat; //this.getGrayPlasticMaterial();
        tFrame.parent = pParent;
        if (this.mOpening.wall != null)
            tFrame.name = "room:wall|" + this.mOpening.wall.id.toString();
        if (this.mOpening.mirrorHorizontal) {
            tFrame.position.z = -tFrame.position.z;
        }
        this.openOpening1(tFrame, protPos, pLeft);
        this.prepare3dMesh(tFrame);
        let tglassInlay = this.createGlassInlay(tFrame, pDouble, pLeft, pDoorLeaf_Depth, pFRAME_Thickness);
        if (this.mOpening.OpeningParams.privacyFilter)
            this.createPrivacyFilter(tglassInlay, pDouble, pLeft);
        return (tFrame);
    }
    createGlassInlay(pParent, pDouble, pLeft, pLeafThickness, pFRAME_Thickness) {
        let tType = pDouble ? 0.5 : 1;
        const tW = this.mOpening.width * tType;
        let tH = this.mOpening.height;
        const tD = 0.005;
        if (this.mOpening.OpeningParams.fanlight) {
            tH = this.mOpening.height - this.mOpening.OpeningParams.fanlightHeight + pFRAME_Thickness;
        }
        var tGlassInlay = CreateBox("", {
            width: tW - 0.01,
            height: tH - 0.01,
            depth: tD
        }, this.mScene);
        if (this.mOpening.mirrorHorizontal)
            tGlassInlay.position.z = -tGlassInlay.position.z;
        tGlassInlay.material = this.getSheetGlassMaterial();
        tGlassInlay.parent = pParent;
        if (this.mOpening.wall != null)
            tGlassInlay.name = "room:wall|" + this.mOpening.wall.id.toString();
        this.prepare3dMesh(tGlassInlay);
        return (tGlassInlay);
    }
    createLeaf_Glass(pParent, protPos, pDoorLeaf_Thickness, pDouble, pLeft = true, pFRAME_Thickness) {
        let tType = pDouble ? 0.5 : 1;
        let tW = this.mOpening.width * tType;
        let tH = this.mOpening.height;
        if (this.mOpening.OpeningParams.fanlight) {
            tH = this.mOpening.height - this.mOpening.OpeningParams.fanlightHeight + pFRAME_Thickness;
        }
        let tLeaf = CreateBox("", {
            width: tW,
            height: tH,
            depth: pDoorLeaf_Thickness
        }, this.mScene);
        if (pDouble) {
            if (pLeft)
                tLeaf.position.x = -tW * tType;
            else
                tLeaf.position.x = tW * tType;
        }
        tLeaf.position.y = tH * 0.5;
        tLeaf.position.z = -pDoorLeaf_Thickness - this.mOpening.depth * 0.5;
        if (this.mOpening.mirrorHorizontal) {
            tLeaf.position.z = -tLeaf.position.z;
        }
        tLeaf.material = this.getSheetGlassMaterial();
        tLeaf.parent = pParent;
        if (this.mOpening.wall != null)
            tLeaf.name = "room:wall|" + this.mOpening.wall.id.toString();
        this.openOpening1(tLeaf, protPos, pLeft);
        this.prepare3dMesh(tLeaf);
        if (this.mOpening.OpeningParams.privacyFilter)
            this.createPrivacyFilter(tLeaf, pDouble, pLeft);
        return (tLeaf);
    }
    // tslint:disable-next-line:cyclomatic-complexity
    createHandle(pLeaf, pFrameThickness, pLeafDepth, pDouble, pLeft = true, pDoorType) {
        let tType = pDouble ? 0.5 : 1;
        let tW = this.mOpening.width * tType;
        let tH = this.mOpening.height;
        let tmeshPosX = 0;
        let tmeshPosY = -tH * 0.5 + this.mOpening.handleHeight;
        let tmeshPosZ = 0;
        let thandle1PosX = 0;
        let tBaseDepth = pFrameThickness + 0.02;
        let tPoleDepth = tBaseDepth + 0.06;
        let tOffX = 0;
        if (pLeaf.position.y !== 0) {
            tOffX = -tW * 0.5;
            tmeshPosZ = 0;
        }
        else {
            tmeshPosZ = pLeafDepth * 0.5;
        }
        if (pDouble) {
            if (pLeft) {
                tmeshPosX = tW - 0.07 + tOffX;
                thandle1PosX = this.mOpening.mirrorVertical ? -0.055 : 0.055;
            }
            else {
                tmeshPosX = 0.07 + tOffX;
                thandle1PosX = this.mOpening.mirrorVertical ? 0.055 : -0.055;
            }
        }
        else {
            tmeshPosX = this.mOpening.mirrorVertical ? 0.07 + tOffX : tW - 0.07 + tOffX;
            thandle1PosX = this.mOpening.mirrorVertical ? -0.055 : 0.055;
        }
        let tHandleBase = CreateBox("", { width: 0.06, height: 0.20, depth: pFrameThickness + 0.02 }, this.mScene);
        let tHandlePole = CreateBox("", { width: 0.02, height: 0.02, depth: tPoleDepth }, this.mScene);
        let tHandle1 = CreateBox("", { width: 0.13, height: 0.02, depth: 0.02 }, this.mScene);
        tHandleBase.position = new Vector3(tmeshPosX, tmeshPosY - 0.05, tmeshPosZ);
        tHandlePole.position = new Vector3(tmeshPosX, tmeshPosY, tmeshPosZ);
        tHandle1.position = new Vector3(tmeshPosX - thandle1PosX, tmeshPosY, tmeshPosZ + 0.07);
        let tHandle2 = tHandle1.clone("");
        tHandle2.position.z = tmeshPosZ - 0.07;
        let tMesh = Mesh.MergeMeshes([tHandleBase, tHandlePole, tHandle1, tHandle2]);
        if (pLeaf.position.y === 0) {
            tMesh.position.y = this.mOpening.height * 0.5;
        }
        tMesh.material = this.getMetalMaterial();
        tMesh.parent = pLeaf;
        if (this.mOpening.wall != null) {
            tMesh.name = "room:wall|" + this.mOpening.wall.id.toString();
        }
        this.prepare3dMesh(tMesh);
        return (tMesh);
    }
    // tslint:disable-next-line:cyclomatic-complexity
    createHandle_Glass(pLeaf, pFrameThickness, pDouble, pLeft = true) {
        let tType = pDouble ? 0.5 : 1;
        let tW = this.mOpening.width * tType;
        let tH = this.mOpening.height;
        //handle
        let tBaseDepth = pFrameThickness + 0.02;
        let tHandleBase = CreateBox("", {
            width: 0.10, height: 0.06, depth: pFrameThickness
        }, this.mScene);
        if (pDouble) {
            if (pLeft)
                tHandleBase.position.x = tW * 0.5 - 0.07;
            else
                tHandleBase.position.x = -tW * 0.5 + 0.07;
        }
        else {
            tHandleBase.position.x = tW * 0.5 - 0.07;
        }
        tHandleBase.position.y = 0; //-tH * 0.05 + this.mOpening.handleHeight;
        let t_handlePos = CreateBox("", {
            width: 0.06, height: 0.06, depth: 0.06
        }, this.mScene);
        t_handlePos.position.x += this.mOpening.width * 0.5 - 0.07;
        t_handlePos.position.y = -tH * 0.05 + 0.03;
        t_handlePos.visibility = 0;
        t_handlePos.parent = pLeaf;
        ShadowGenerator.disableMeshShadow(t_handlePos);
        if (this.mOpening.mirrorVertical) {
            tHandleBase.position.x = -tHandleBase.position.x;
            t_handlePos.position.x = -t_handlePos.position.x;
        }
        this.prepare3dMesh(t_handlePos);
        let tPoleDepth = tBaseDepth + 0.06;
        let tHandlePole = CreateCylinder("", { height: 0.10, diameter: 0.0075, tessellation: 8 }, this.mScene);
        let axis = new Vector3(1, 0, 0);
        let angle = Math.PI / 2;
        let quaternion = Quaternion.RotationAxis(axis, angle);
        tHandlePole.rotationQuaternion = quaternion;
        tHandlePole.position = tHandleBase.position.clone();
        tHandlePole.position.x -= -0.00;
        tHandlePole.position.y -= -0.00;
        var tHandle1 = CreateCylinder("", { height: 0.14, diameter: 0.018, tessellation: 8 }, this.mScene);
        let axis1 = new Vector3(0, 0, 1);
        let angle1 = Math.PI / 2;
        let quaternion1 = Quaternion.RotationAxis(axis1, angle1);
        tHandle1.rotationQuaternion = quaternion1;
        tHandle1.position = tHandlePole.position.clone();
        if (pDouble) {
            if (pLeft)
                tHandle1.position.x -= this.mOpening.mirrorVertical ? -0.055 : 0.055;
            else
                tHandle1.position.x -= this.mOpening.mirrorVertical ? 0.055 : -0.055;
        }
        else
            tHandle1.position.x -= this.mOpening.mirrorVertical ? -0.055 : 0.055;
        tHandle1.position.z -= tPoleDepth * 0.5 - 0.01;
        let tHandle2 = tHandle1.clone("");
        tHandle2.position.z = -tHandle2.position.z;
        this.mOpening.setHandlePos(t_handlePos.absolutePosition);
        let tMesh = Mesh.MergeMeshes([tHandleBase, tHandlePole, tHandle1, tHandle2]);
        if (tMesh != null) {
            tMesh.position.y = this.mOpening.handleHeight - pLeaf.position.y;
            tMesh.material = this.getMetalMaterial();
            tMesh.parent = pLeaf;
            if (this.mOpening.wall != null)
                tMesh.name = "room:wall|" + this.mOpening.wall.id.toString();
            this.prepare3dMesh(tMesh);
        }
    }
    createHandle_Glass1(pLeaf) {
        let tW = this.mOpening.width;
        let tH = this.mOpening.height;
    }
}
//// protected /////////////////////////////////////////////////////////////////////////////
OpeningGeometry.PROP_KEY_WINDOWSEGMENTS = "room:Windows:Segments";
OpeningGeometry.PROP_KEY_WINDOWSEGMENTSWIDTH = "room:Windows:ColumnWidth";
OpeningGeometry.PROP_KEY_SILL = "room:Windows:Sill";
OpeningGeometry.PROP_KEY_BLIND = "room:Windows:Blind";
OpeningGeometry.PROP_KEY_BLINDOPENINGANGLE = "room:Windows:BlindOpeningAngle";
OpeningGeometry.PROP_KEY_BLINDOPENINGWIDTH = "room:Windows:BlindOpeningWidth";
OpeningGeometry.PROP_KEY_PRIVACYFILTER = "room:Windows:PrivacyFilter";
OpeningGeometry.PROP_KEY_GLAZINGBARS = "room:Windows:GlazingBars";
OpeningGeometry.PROP_KEY_GLAZINGBARS_WIDTH = "room:Windows:GlazingBarsWidth";
OpeningGeometry.PROP_KEY_GLAZINGBARS_HORIZONTAL = "room:Windows:GlazingBarsHorizontal";
OpeningGeometry.PROP_KEY_GLAZINGBARS_VERTICAL = "room:Windows:GlazingBarsVertical";
//// private ///////////////////////////////////////////////////////////////////////////////
OpeningGeometry.MAT_KEY_MILKGLASS = "room:openingGeometry:milkGlass";
OpeningGeometry.MAT_KEY_SHEETGLASS = "room:openingGeometry:sheetGlass";
OpeningGeometry.MAT_KEY_WHITEPLASTIC = "room:openingGeometry:whitePlastic";
OpeningGeometry.MAT_KEY_GRAYPLASTIC = "room:openingGeometry:grayPlastic";
OpeningGeometry.MAT_KEY_METAL = "room:openingGeometry:metal";
